export default __webpack_public_path__ + "static/media/r_wdt_c_3.14c1568a.mp3";